// extracted by mini-css-extract-plugin
export default {"wrapper":"Separator_wrapper__3Buv4","separator":"Separator_separator__5htBe"};